import React from 'react';

export type HeadingLevelContextType = {
  level: number;
};

// Components within `common-components` and `design-system` both need
// a reference to this exact context object. However there are circular
// dependency issues between those packages, so this context object exists
// in `@zapier/common-utils`.
const HeadingLevelContext: React.Context<HeadingLevelContextType> = React.createContext(
  {
    level: 1,
  }
);

export const useHeadingLevel = () => React.useContext(HeadingLevelContext);

export const HeadingLevelProvider: React.FC<HeadingLevelContextType> = ({
  level = 1,
  children,
}) => {
  return (
    <HeadingLevelContext.Provider
      value={{
        level,
      }}
    >
      {children}
    </HeadingLevelContext.Provider>
  );
};
